var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobe({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66602 7.91653C1.66602 4.47053 4.47068 1.66653 7.91602 1.66653C11.362 1.66653 14.166 4.47053 14.166 7.91653C14.166 11.3632 11.362 14.1665 7.91602 14.1665C4.47068 14.1665 1.66602 11.3632 1.66602 7.91653ZM8.41602 7.4112V2.80853C9.31802 3.29387 10.1707 5.0312 10.2787 7.4112H8.41602ZM4.55535 7.4112C4.62602 5.69587 5.05468 4.1972 5.70802 3.15987C4.06002 3.92853 2.87268 5.5232 2.69202 7.4112H4.55535ZM2.69202 8.4112H4.55468C4.62402 10.1312 5.05335 11.6339 5.70802 12.6732C4.05668 11.9032 2.86935 10.3039 2.69202 8.4112ZM10.1247 12.6732C10.7793 11.6339 11.2087 10.1312 11.278 8.4112H13.1407C12.9633 10.3039 11.776 11.9032 10.1247 12.6732ZM8.41602 8.4112V13.0245C9.31935 12.5392 10.1733 10.7972 10.2787 8.4112H8.41602ZM7.41668 8.4112V13.0245C6.51335 12.5392 5.65935 10.7972 5.55402 8.4112H7.41668ZM7.41668 7.4112V2.80853C6.51468 3.29387 5.66202 5.0312 5.55402 7.4112H7.41668ZM13.1407 7.4112H11.2773C11.2067 5.69587 10.778 4.1972 10.1247 3.15987C11.7727 3.92853 12.96 5.5232 13.1407 7.4112Z",
    fill: "#0F67BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/Globe.aede7a846d67bdcea173a265dfa566e7.svg";
export { ForwardRef as ReactComponent };